export default "__VITE_ASSET__YHnCzbVY__"